import { UrlShare } from 'shared/constants'

export const getShareUrl = (url: string) => {
  return `${UrlShare}${window.location.origin}${url}`
}
